<template>
  <section>
    <div class="vx-col w-full mb-base">
      <vx-card class="mt-6">
        <form>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="vs-input--label">Start at</label>
              <datepicker
                v-model="filter.date_start"
                placeholder="Select Date"
                name="startAt"
                color="dark"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="vs-input--label">End at</label>
              <datepicker
                v-model="filter.date_end"
                placeholder="Select Date"
                name="endAt"
                color="dark"
              />
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-6">
                <div class="flex flex-wrap justify-begin">
                  <vs-button @click.prevent="generateChart"> Search </vs-button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>

      <div class="vx-row">
        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 class="text-bold-700 mt-1 mb-25">Contact Careline</h2>
            <div id="chart-pie"></div>
          </vx-card>
        </div>

        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-1-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-1"></div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-2-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-2"></div>
          </vx-card>
        </div>

        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-3-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-3"></div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-4-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-4"></div>
          </vx-card>
        </div>

        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-5-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-5"></div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-6-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-6"></div>
          </vx-card>
        </div>

        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-7-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-7"></div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-8-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-8"></div>
          </vx-card>
        </div>

        <div class="mt-6 vx-col md:w-1/2 w-full">
          <vx-card class="vx-card">
            <h2 id="chart-graph-9-h2" class="text-bold-700 mt-1 mb-25"></h2>
            <div id="chart-graph-9"></div>
          </vx-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ApexCharts from 'apexcharts'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      filter: {
        date_start: moment().utc().startOf('day').subtract(7, 'days').toDate(),
        date_end: moment().utc().startOf('day').toDate()
      },
      stoolColors: [
        '#000000',
        '#FFF3CA',
        '#843C01',
        '#EF7D22',
        '#FFC100',
        '#365720',
        '#FF0000'
      ],
      chartColors: [
        '#7367F0',
        '#EA5455',
        '#FF9F43',
        '#0DCCE1',
        '#8F80F9',
        '#FFC085',
        '#f29292',
        '#1edec5'
      ],
      chartPie: null,
      graph: [null, null, null, null, null, null, null, null, null]
    }
  },
  computed: {},
  methods: {
    ...mapActions('stoolDashboard', ['fetch']),
    ...mapGetters('stoolDashboard', ['lists']),
    generateChart() {
      this.fetch(this.filter).then((response) => {
        // console.log(response)
        this.publishChart(response)
      })
    },
    publishChart(data) {
      if (this.hasRender) {
        //document.querySelector('#chart-pie').innerHTML = ''
        this.chartPie.destroy()
        for (let i = 0; i < data.graph.length; i++) {
          this.graph[i].destroy()
          //document.querySelector(`#chart-graph-${i + 1}`).innerHTML = ''
        }
      }
      this.chartPie = this.renderPie('#chart-pie', [
        data.pie.Contact,
        data.pie.NoContact
      ])
      for (let i = 0; i < data.graph.length; i++) {
        document.querySelector(`#chart-graph-${i + 1}-h2`).textContent =
          `${data.graph[i].x_label} - ${data.graph[i].y_label} (Total:  ${data.graph[i].total})`
        this.graph[i] = this.renderChart(
          `#chart-graph-${i + 1}`,
          data.graph[i].data,
          data.graph[i].label,
          data.graph[i].is_stool,
          data.graph[i].x_label === 'Food Type'
        )
      }
      this.hasRender = true
    },
    dateFormat(date) {
      const dt = moment(date)
      return dt.format('D MMM YY')
    },

    renderPie(chart_id, series_data) {
      const options = {
        colors: ['#0DCCE1', '#EA5455'],
        series: series_data,
        chart: {
          height: 320,
          type: 'pie'
        },
        labels: ['Contact', 'No Contact'],
        tooltip: { enabled: false },
        dataLabels: {
          enabled: true,
          formatter(val, opt) {
            return `${opt.w.config.series[opt.seriesIndex]}   (${val.toFixed(0)}%)`
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      }
      const chart = new ApexCharts(document.querySelector(chart_id), options)
      chart.render()
      return chart
    },

    renderChart(chart_id, series_data, series_label, is_stool, is_food) {
      let colors = this.chartColors
      if (is_stool) {
        colors = this.stoolColors
      }

      const options = {
        colors,
        series: series_data,
        chart: {
          type: 'bar',
          height: is_food ? 310 : 250,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          },
          events: {
            mounted: (chartContext, config) => {
              setTimeout(() => {
                // eslint-disable-next-line no-use-before-define
                addAnnotations(config)
              })
            },
            updated: (chartContext, config) => {
              setTimeout(() => {
                // eslint-disable-next-line no-use-before-define
                addAnnotations(config)
              })
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          },
          dataLabels: {
            enabled: false
          }
        },
        xaxis: {
          categories: series_label,
          labels: {
            rotate: -30,
            hideOverlappingLabels: false,
            trim: true,
            offsetY: 0,
            style: {
              fontSize: 10
            },
            formatter(value) {
              //, timestamp, opts
              return !value || typeof value !== 'string'
                ? ''
                : value.includes(',')
                  ? value.replaceAll(',', '+,').split(',')
                  : value
            }
          }
        },
        yaxis: {
          labels: {
            formatter(val) {
              return val.toFixed(0)
            }
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'left'
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            // eslint-disable-next-line no-unused-vars
            formatter(value, { series, seriesIndex, dataPointIndex, w }) {
              const currentTotal = series.reduce(
                (a, s) => a + s[dataPointIndex],
                0
              )
              return `${value} (${((value / currentTotal) * 100).toFixed(0)}%)`
            }
          },
          fixed: {
            enabled: false,
            position: 'topRight'
          },
          followCursor: true
        },
        dataLabels: {
          enabled: true,
          //enabledOnSeries: [series_data.length-1],
          //textAnchor: "center",
          style: {
            fontSize: 7
          },
          formatter(_val, opt) {
            const series = opt.w.config.series
            const idx = opt.dataPointIndex
            //if (idx < (series_data.length-1)) return _val;
            const total = series.reduce(
              (total, self) => total + self.data[idx],
              0
            )
            return `${_val} (${((_val / total) * 100).toFixed(0)}%)`
          }
        }
      }

      const chart = new ApexCharts(document.querySelector(chart_id), options)

      const calcHorizontalY = (config, index) => {
        const catLength = series_label.length
        const yRange = config.globals.yRange[0]
        const minY = config.globals.minY
        const halfBarHeight = yRange / catLength / 2

        return (
          // eslint-disable-next-line no-mixed-operators
          minY + halfBarHeight + 2 * halfBarHeight * (catLength - 1 - index)
        )
      }

      const adjustPointAnnotationXCoord = (config, index) => {
        const gridWidth = config.globals.gridWidth
        const seriesTotal = config.globals.stackedSeriesTotals[index]
        const minY = config.globals.minY
        const yRange = config.globals.yRange[0]
        const xOffset = (gridWidth * (seriesTotal + Math.abs(minY))) / yRange
        const circle = document.querySelector(
          `.apexcharts-point-annotations circle:nth-of-type(${index + 1})`
        )
        const labelField = document.querySelector(
          `.apexcharts-point-annotations rect:nth-of-type(${index + 1}`
        )
        const labelFieldXCoord = parseFloat(labelField.getAttribute('x'))
        const text = document.querySelector(
          `.apexcharts-point-annotations text:nth-of-type(${index + 1}`
        )

        labelField.setAttribute('x', labelFieldXCoord + xOffset)
        text.setAttribute('x', xOffset)
        // console.log(labelFieldXCoord);
        circle.setAttribute('cx', xOffset)
      }

      const addAnnotations = (config) => {
        const seriesTotals = config.globals.stackedSeriesTotals
        const isHorizontal = options.plotOptions.bar.horizontal
        chart.clearAnnotations()

        try {
          series_label.forEach((category, index) => {
            chart.addPointAnnotation(
              {
                // eslint-disable-next-line multiline-ternary
                y: isHorizontal
                  ? // eslint-disable-next-line multiline-ternary
                    calcHorizontalY(config, index)
                  : seriesTotals[index],
                x: isHorizontal ? 0 : category,
                label: {
                  text: `${seriesTotals[index]}`
                },
                marker: {
                  size: 0
                }
              },
              false
            )

            if (isHorizontal) {
              adjustPointAnnotationXCoord(config, index)
            }
          })
        } catch (error) {
          // console.log(`Add point annotation error: ${error.message}`)
        }
      }

      chart.render()
      return chart
    }
  },
  mounted() {
    this.generateChart()
  }
}
</script>

<style lang="sass" scoped>
.chart
  width: 100%
  overflow: scroll
</style>
